import React from 'react';
import PropTypes from 'prop-types';
import { Button, FormControl, Modal, Table } from 'react-bootstrap';
import StepNav from './StepNav.jsx';
import Flatpickr from 'react-flatpickr';
import classnames from 'classnames';

const AddProjectModalProjectSettings = ({
	steps,
	step,
	confirmAndClose,
	finish,
	startDate,
	endDate,
	remainingDurationUnit,
	hoursPerDay,
	displayTime,
	allowNotStartDurationChanges,
	addProjectStartDateChange,
	addProjectEndDateChange,
	addProjectRemainingDurationUnitChange,
	addProjectHoursPerDayChange,
	addProjectUpdateDisplayTime,
	addProjectAllowNotStartDurationChanges
}) => {
	return (
		<React.Fragment>
			<Modal.Body>
				<StepNav steps={steps} step={step} />
				<Table className="projectSetupTable">
					<tbody>
						<tr>
							<td>Timescale Start</td>
							<td className={classnames('datePickerColumn', {empty: startDate === ''})}>
								<Flatpickr
									className="datePicker startDate form-control"
									options={{
										dateFormat: 'd-M-Y',
										disableMobile: 'true',
										onChange: addProjectStartDateChange
									}}
									value={startDate} />
							</td>
						</tr>
						<tr>
							<td>Timescale Finish</td>
							<td className={classnames('datePickerColumn', {empty: endDate === ''})}>
								<Flatpickr
									className="datePicker endDate form-control"
									options={{
										dateFormat: 'd-M-Y',
										disableMobile: 'true',
										onChange: addProjectEndDateChange
									}}
									value={endDate} />
							</td>
						</tr>
						<tr>
							<td>Remaining Duration Unit</td>
							<td>
								<FormControl
									componentClass="select"
									value={remainingDurationUnit}
									onChange={addProjectRemainingDurationUnitChange}>
									<option value="hours">Hours</option>
									<option value="days">Days</option>
								</FormControl>
							</td>
						</tr>
						<tr>
							<td>Hours Per Day</td>
							<td>
								<FormControl
									type="number"
									value={hoursPerDay}
									onChange={addProjectHoursPerDayChange}>
								</FormControl>
							</td>
						</tr>
						<tr>
							<td>
								<label htmlFor="add-project-display-time">Display Time and Date</label>
							</td>
							<td>
								<input
									id="add-project-display-time"
									type="checkbox"
									checked={!!displayTime}
									onChange={addProjectUpdateDisplayTime} />
							</td>
						</tr>
						<tr>
							<td>
								<label htmlFor="add-project-allow-not-start">Allow TK_NotStart duration changes</label>
							</td>
							<td>
								<input
									id="add-project-allow-not-start"
									type="checkbox"
									checked={!!allowNotStartDurationChanges}
									onChange={addProjectAllowNotStartDurationChanges} />
							</td>
						</tr>
					</tbody>
				</Table>
			</Modal.Body>
			<Modal.Footer>
				<Button onClick={confirmAndClose} bsStyle="danger" className="floatLeft">Cancel</Button>
				<Button bsStyle="primary" onClick={finish}>Finish</Button>
			</Modal.Footer>
		</React.Fragment>
	);
};

AddProjectModalProjectSettings.propTypes = {
	steps: PropTypes.array,
	step: PropTypes.number,
	confirmAndClose: PropTypes.func,
	finish: PropTypes.func,
	startDate: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
	endDate: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
	remainingDurationUnit: PropTypes.string,
	hoursPerDay: PropTypes.string,
	displayTime: PropTypes.bool,
	allowNotStartDurationChanges: PropTypes.bool,
	addProjectStartDateChange: PropTypes.func,
	addProjectEndDateChange: PropTypes.func,
	addProjectRemainingDurationUnitChange: PropTypes.func,
	addProjectHoursPerDayChange: PropTypes.func,
	addProjectUpdateDisplayTime: PropTypes.func,
	addProjectAllowNotStartDurationChanges: PropTypes.func
};

export default AddProjectModalProjectSettings;